
import {
  barLineAreaGraphApi,
  fetchYAxisFieldApi,
  fetchXAxisFieldApi,
  getGeneratedSavedApi
} from '@/api/graph'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export const BarLineAreaMixins = {
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Analytics')
    }
  },
  data () {
    return {
      name:'',
      description:'',
      saveGraphPopUp:false,
      generateGraph:false

    }
  },
  mixins:[PermissionMiddleware],
  watch: {
    platform_module_id () {
      this.xAxisFieldId = null
      this.yAxisFieldId = null
      this.fetchXAxis(this.platform_module_id)
      this.generateGraph = false
    },
    xAxisFieldId () {
      if (this.xAxisFieldId) {
        this.yAxisFieldId = null
        this.fetchYAxis(this.platform_module_id, this.xAxisFieldId)
        this.generateGraph = false

      }
    }
  },
  computed: {
    ...mapGetters(['get_platform_modules_item_data']),

    allFieldsSelected () {
      return this.xAxisFieldId && this.yAxisFieldId && this.platform_module_id && ('startDate' in this.dateRange) && 'endDate' in this.dateRange
    },
    saveGraphChecking () {
      return this.allFieldsSelected && this.generateGraph
    }
  },
  methods: {
    async fetchXAxis (platform_module_id) {
      try {
        const responseXAxis = await fetchXAxisFieldApi(platform_module_id)
        this.xAxisFieldOption = responseXAxis.data.data.x_axis
        
      } catch (error) {
        
      }
    },
    async fetchYAxis (platform_module_id, xAxisId) {
      const responseYAxis = await fetchYAxisFieldApi(
        platform_module_id,
        xAxisId
      )
      this.yAxisFieldOption = responseYAxis.data.data.y_axis
      
    },
    async generateGraphApi (type = 'not pie') {
      
      
      const additional_data = {
        start_date:moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        end_date:moment(this.dateRange.endDate).format('YYYY-MM-DD'),
        date_setting:6
      }
    
    
      try {
        const payload = {
          platform_module_id: this.platform_module_id,
          y_axis: this.yAxisFieldId,
          x_axis: this.xAxisFieldId,
          additional_data
        }


        const responseData = await barLineAreaGraphApi(
          localStorage.getItem('customer_id'),
          payload
        )

        this.generateGraph = true


        if (type === 'pie') {
          this.setPieGraphData(responseData.data.data.series, responseData.data.data.labels,
            responseData.data.data.field_name
          )
        } else {
          this.setGraphData(responseData.data.data.series, responseData.data.data.labels,
            responseData.data.data.field_name
          )
        }
        /*  this.setGraphData(responseData.data.data.series, responseData.data.data.labels,
          responseData.data.data.field_name
        ) */


        // this.saveGraphChecking = true
       
        // this.SelectedLineGraphId = null

      } catch (api_error) {
        if ('data' in api_error) {
          this.showSuccessMessage('Error', `${api_error.data.data.message}`, 'danger')
        }
        // 
      }
    },
    openSavePopUp () {
      
      this.saveGraphPopUp = true
    },
   
    async getGenratedSaveData (id, type = 'other') {

      
      const responseData = await getGeneratedSavedApi(localStorage.getItem('customer_id'), id)
      if (type === 'pie') {
        this.setPieGraphData(responseData.data.data.series, responseData.data.data.labels,
          responseData.data.data.field_name)
      } else {
        this.setGraphData(responseData.data.data.series, responseData.data.data.labels,
          responseData.data.data.field_name
        )
      }
      

      const datatype = responseData.data.data.graph.graph_type
      
      const el = document.getElementById(datatype)
      el.scrollIntoView({behavior: 'smooth'})
      
    },
    setPieGraphData (series, labels) {
      // 
      // this.$refs.apexChart.chart.updateSeries([...series])
      this.series = [...series]
      
      this.$refs.apexChart.chart.updateOptions({
        series:[...series]
       
      })
      // 
      // 
      this.chartOptions = {...this.chartOptions,
        
        labels
          
      }
    },
    setGraphData (series, labels, fieldname = 'value') {
      if (fieldname) {
        this.series[0].name = fieldname
      }
      // this.series[0].name = 'yasin'
      
      this.$refs.apexChart.chart.updateSeries([
        {
          name:this.series[0].name,
          data:[...series]
        }
      ])
      // 
      this.chartOptions = {...this.chartOptions,
        ...{
          xaxis: {
            categories:  [...labels]
          }
        }}
    },
    closeSavePopUp () {
      setTimeout(() => {
        this.saveGraphPopUp = false
        this.generateGraph = false
      })
    }
  
  }
}